import { SCORE_DIMENSIONS } from '../../shared/scoreDimensions';
import type { SessionParticipant } from '../types';

/** Entries recorded before the observation model changed (2026-10-15) are
 *  complete without the "défi" letter. Mirrors MODEL_V2_DATE on the server. */
export const MODEL_V2_DATE = '2026-10-15';

/** An entry counts as recorded once presence is settled and, for someone
 *  present, every observation letter is set. Card-taking recorded with the
 *  October 2026 yes/no (no letter) still counts. */
export function isRecorded(p: SessionParticipant, sessionDate: string): boolean {
  if (p.presence === 'absent') return true;
  if (p.presence !== 'present') return false;
  return SCORE_DIMENSIONS.every((d) =>
    d.key === 'defi' && sessionDate < MODEL_V2_DATE ? true
      : d.key === 'prise_cartes' ? p.score_prise_cartes != null || p.takes_cards != null
        : p[d.field] != null);
}
